import { IconProps } from 'components/icons/Icons.types';
import React from 'react';
import styles from './Icon.module.scss';

const UnlockIcon: React.FC<IconProps> = ({
  className = '',
  size = 24,
  color = '#fffff0',
  fillColor = 'transparent',
  fillOpacity = 1,
  circleStrokeColor = '#fffff0',
}) => {
  const baseCls = `${styles.IconContainer} ${className}`;
  return (
    <div className={baseCls}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill={fillColor}
          fillOpacity={fillOpacity}
          cx="12"
          cy="12"
          r="10.5"
          stroke={circleStrokeColor}
          strokeWidth={'1.5px'}
        />
        <path
          fillRule="evenodd"
          clipRule="nonzero"
          d="M15.75 11.7c.369 0 .675.306.675.675v4.05c0 .369-.306.675-.675.675h-8.1c-.369 0-.675-.306-.675-.675v-4.05c0-.369.306-.675.675-.675h8.1Zm.675-3.375c0-2.232-1.818-4.05-4.05-4.05s-4.05 1.818-4.05 4.05V10.35H7.65c-1.125 0-2.025.9-2.025 2.025v4.05c0 1.125.9 2.025 2.025 2.025h8.1c1.125 0 2.025-.9 2.025-2.025v-4.05c0-1.125-.9-2.025-2.025-2.025H9.675V8.325c0-1.494 1.206-2.7 2.7-2.7s2.7 1.206 2.7 2.7h1.35Z"
          fill={color}
          stroke={color}
          strokeWidth={'0.2px'}
        />
      </svg>
    </div>
  );
};

export default UnlockIcon;
